module.exports = __webpack_public_path__ + "img/logo Q-CON now.2166276c.jpg";